export const customersData = [
  {
    name: "官网渠道间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 0,
  },
  {
    name: "协议客户间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 1,
  },
  {
    name: "OTA间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 2,
  },
  {
    name: "Wholesale间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 3,
  },
  {
    name: "Package间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 4,
  },
  {
    name: "公司团队间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 5,
  },
  {
    name: "旅行团队间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 6,
  },
  {
    name: "其他间夜数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 7,
  },
  {
    name: "当月维修房数",
    mtd: 0,
    date: "",
    occ: 0,
    sold: 0,
    sort: 8,
  },
];
export const foodData = [
  {
    name: "餐饮部",
    project: "餐饮部总收入",
    act: 0,
    bud: 0,
    cop: 0,
    af: 0,
    f: 0,
    sort: 0,
  },
  {
    name: "餐饮部",
    project: "宴会总收入",
    act: 0,
    bud: 0,
    cop: 0,
    af: 0,
    f: 0,
    sort: 1,
  },
  {
    name: "餐饮部",
    project: "中餐厅收入",
    act: 0,
    bud: 0,
    cop: 0,
    af: 0,
    f: 0,
    sort: 2,
  },
  {
    name: "餐饮部",
    project: "全日制餐厅收入",
    act: 0,
    bud: 0,
    cop: 0,
    af: 0,
    f: 0,
    sort: 3,
  },
  {
    name: "餐饮部",
    project: "特色餐厅收入",
    act: 0,
    bud: 0,
    cop: 0,
    af: 0,
    f: 0,
    sort: 4,
  },
  {
    name: "餐饮部",
    project: "客房送餐收入",
    act: 0,
    bud: 0,
    cop: 0,
    af: 0,
    f: 0,
    sort: 5,
  },
];

export const commentsData = [
  {
    name: "官网",
    order: 0,
    comment: 0,
    fraction: 0,
    total: 0,
    sort: 0,
  },
  {
    name: "携程",
    order: 0,
    comment: 0,
    fraction: 0,
    total: 0,
    sort: 1,
  },
  {
    name: "美团",
    order: 0,
    comment: 0,
    fraction: 0,
    total: 0,
    sort: 2,
  },
  {
    name: "飞猪",
    order: 0,
    comment: 0,
    fraction: 0,
    total: 0,
    sort: 3,
  },
  {
    name: "当月Medallia分数",
    order: 0,
    comment: 0,
    fraction: 0,
    total: 0,
    sort: 4,
  },
];

export const platformData = [
  {
    name: "美团大众点评（中餐厅）",
    order: "",
    comment: 0,
    fraction: 0,
    total: 4.6,
    sort: 0,
  },
  {
    name: "美团大众点评（西餐厅）",
    order: "",
    comment: 0,
    fraction: 0,
    total: 4.6,
    sort: 1,
  },
  {
    name: "美团大众点评（宴会厅）",
    order: "",
    comment: 0,
    fraction: 0,
    total: 4.6,
    sort: 2,
  },
];

export const submarketData = [
  {
    name1: "预订订单排名",
    value1: 0,
    name2: "入住间夜排名",
    value2: 0,
    name3: "新签协议份数MTD",
    value3: 0,
    sort: 0,
  },
  {
    name1: "携程APP访客排名",
    value1: 0,
    name2: "曝光人数排名",
    value2: 0,
    name3: "协议订单量MTD",
    value3: 0,
    sort: 1,
  },
  {
    name1: "携程APP转化率排名",
    value1: 0,
    name2: "浏览器转化率排名",
    value2: 0,
    name3: "本地协议单位",
    value3: 0,
    sort: 2,
  },
  {
    name1: "PSI分排名",
    value1: 0,
    name2: "支付转化率排名",
    value2: 0,
    name3: "新签协议份数MTD",
    value3: 0,
    sort: 3,
  },
  {
    name1: "点评分排名",
    value1: 0,
    name2: "HOS排名",
    value2: 0,
    name3: "协议订单量MTD",
    value3: 0,
    sort: 4,
  },
];



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/kpifollow/data.js